<template>
    <div id="app">
        <Header />
        <div id="nav3" v-if="!!section">
            <template v-if="logged && privacyOK && section == 'production'">
                <router-link to="/pimymachines">My Machines</router-link>
                <router-link to="/piopenpointslist"> | Open Points List</router-link>
                <router-link to="/picalendar"> | Calendar</router-link>
                <router-link to="/pisupport"> | Support</router-link>
                <router-link v-if="mm" to="/piallmachines"> | All Machines</router-link>
                <router-link v-if="mm" to="/pimachinearchive"> | Machine Archive</router-link>
                <router-link v-if="mm" to="/pimachinesstatus"> | Machines Status</router-link>
            </template>
            <template v-if="logged && privacyOK && section == 'installation'">
                <router-link to="/pimymachines">My Machines</router-link>
                <router-link to="/piopenpointslist"> | Open Points List</router-link>
                <router-link to="/picalendar"> | Calendar</router-link>
                <router-link to="/pisupport"> | Support</router-link>
                <router-link v-if="mm" to="/piallmachines"> | All Machines</router-link>
                <router-link v-if="mm" to="/pimachinearchive"> | Machine Archive</router-link>
                <router-link v-if="mm" to="/pimachinesstatus"> | Machines Status</router-link>
            </template>
            <template v-if="logged && privacyOK && section == 'servicecare'">
                <!-- <router-link to="/">Home</router-link> -->
                <router-link to="/scmachines">Machines</router-link>
                <!-- <router-link to="/scbillofmaterials"> | Bill Of Materials</router-link> -->
                <router-link to="/scspareparts"> | Spare Parts</router-link>
                <!-- <router-link v-if="a && !c" to="/scrfq"> | RFQ</router-link> -->
                <router-link to="/scassistance"> | Tickets/Assistance</router-link>
                <router-link to="/screpairs"> | Repairs</router-link>
                <router-link to="/screminders"> | Reminders</router-link>
                <!-- <router-link to="/sccontracts"> | Contracts</router-link> -->
                <router-link to="/scarch"> | Campaign Archive</router-link>
                <router-link v-if="m" to="/users"> | Users</router-link>
                <router-link v-if="mm" to="/siteadmin"> | Site Admin</router-link>
                <router-link v-if="mm" to="/logs"> | Logs</router-link>
                <router-link v-if="mm" to="/logs2"> | Logs 2</router-link>
                <router-link v-if="mm" to="/overrides"> | Overrides</router-link>
                <router-link to="/support"> | Support</router-link>
            </template>
        </div>
        <router-view :key="$route.name" />
    </div>
</template>

<script>
import Header from './components/Header.vue'
export default {
    name: 'App',
    components: {
        Header
    },
    data() {
        return {

        }
    },
    mounted() {
        console.log("App mounted", this.$route.path)
        if (!this.session && this.$route.path != "/choose") {
            this.$router.push("/choose");
        }
    },
    computed: {
        section() {
            return this.$store.getters.section
        },
        mm() { // Master Marsilli
            // console.log("mm ?",this.$store.getters.master ,this.$store.getters.marsilli)
            let master = this.$store.getters.master
            let marsilli = this.$store.getters.marsilli
            return master && marsilli
        },
        c() { // Client
            let marsilli = this.$store.getters.marsilli
            return !marsilli
        },
        m() { // Master
            // console.log("mm ?",this.$store.getters.master ,this.$store.getters.marsilli)
            let master = this.$store.getters.master
            return master
        },
        a() { // Amministrativo
            // console.log("mm ?",this.$store.getters.master ,this.$store.getters.marsilli)
            let master = this.$store.getters.amministrativo
            return master
        },
        logged() {
            // console.log("logged app",this.$store.getters.logged)
            return this.$store.getters.logged
        },
        privacyOK() {
            return this.$store.getters.privacyOK
        },
    },
}
</script>

<style lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    height: 100%;
}

#nav3 {
    padding: 30px;
    height: 9vh;
    /* 84px; */
    min-height: 9vh;
    /* 84px; */
    max-height: 9vh;

    /* 84px; */
    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #9A240D;
        }
    }
}
</style>
